function initOfferDrawerComponent() {
    const initOfferDrawerLogic = {
        showOfferDrawerState: false,
        showOfferDrawerFct() {
            this.showOfferDrawerState = !this.showOfferDrawerState
        }
    };

    return initOfferDrawerLogic;
}

export default initOfferDrawerComponent();